import React from "react";

import MobileDialog from "@app/analytics/MeetingReport/components/MobileDialog";

import { Column } from "@rui/Stack";

import { DownloadButtonLink } from "./styles";
import type { DownloadProps } from "./types";

const DownloadMenuDialog = ({ downloads }: DownloadProps) => {
  return (
    <MobileDialog id="downloads" title="Download">
      <Column spacing={1}>
        {Object.values(downloads).map(
          ({ href, download, onClick, label, show }) => {
            if (!show) return null;
            return (
              <DownloadButtonLink
                key={label}
                href={href}
                download={download}
                onClick={onClick}
              >
                {label}
              </DownloadButtonLink>
            );
          }
        )}
      </Column>
    </MobileDialog>
  );
};

export default DownloadMenuDialog;
